module.exports = __webpack_public_path__ + "static/media/beach.937e03f6.png";